import { render, staticRenderFns } from "./GBoothTemplateForm.vue?vue&type=template&id=0908d6dc&scoped=true&"
import script from "./GBoothTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./GBoothTemplateForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBoothTemplateForm.vue?vue&type=style&index=0&id=0908d6dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0908d6dc",
  null
  
)

export default component.exports